/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-09-14 14:06:13
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2023-05-11 11:36:24
 * @FilePath: \exevnt\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Rain from "../views/rain"
import Typhoon from "../views/typhoon"
import Heat from "../views/heat"
import Dry from "../views/dry"
import Cold from "../views/cold"
import Clime from "../views/clime"
import Manger from "../views/Manger"
import Gdp from "../views/Manger/Gdp"
import Login from "../views/Login/login"
import Home from "../views/Home/home"
import store from "../store/index"
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    // beforeEnter: (to, from, next) => {
    //   if (store.state.isLogined) {
    //     next()
    //   } else {
    //     next({ name: "Login" })
    //   }
    // },
    redirect: "/rain",
    children: [
      {
        path: '/rain',
        name: 'Rain',
        component: Rain
      },
      {
        path: '/dry',
        name: 'Dry',
        component: Dry
      },
      {
        path: '/typhoon',
        name: 'Typhoon',
        component: Typhoon
      },
      {
        path: '/heat',
        name: 'Heat',
        component: Heat
      },
      {
        path: '/cold',
        name: 'Cold',
        component: Cold
      },
      {
        path: '/clime',
        name: 'Clime',
        component: Clime
      },

      {
        path: '/manger',
        name: 'Manger',
        component: Manger,
        redirect: "/gdp",
        children: [
          {
            // 当 /user/:id/profile 匹配成功
            // UserProfile 将被渲染到 User 的 <router-view> 内部
            path: '/gdp',
            component: Gdp,
          },

        ],
      }
    ]
  },

]
// router.beforeEach((to, from, next) => {
//   if (store.state.isLogined === true) {
//     next()
//   } else {
//     if (to.path === "/") {
//       next()
//     } else {
//       next('/')
//     }
//   }
// })
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
